// extracted by mini-css-extract-plugin
export default {"root":"Knqol","backButton":"yWLQ0"};